module.exports = __webpack_public_path__ + "img/billinghistory.6dccc220.svg";